export const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN || "";
